(() => {
  const STORAGE_KEY = 'american-stride-wishlist';
  const HEART_SVG = `
    <svg aria-hidden="true" viewBox="0 0 24 24" fill="none">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/>
    </svg>`;

  const normalizeUrl = (value) => {
    try {
      const url = new URL(value, location.origin);
      return `${url.origin}${url.pathname}`;
    } catch {
      return value;
    }
  };

  const readWishlist = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter((item) => item?.url && item?.title) : [];
    } catch {
      return [];
    }
  };

  const writeWishlist = (items) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch {
      return;
    }
    updateInterface();
  };

  const getProductFromCard = (card) => {
    const link = card.querySelector('.card__heading a[href*="/products/"], a[href*="/products/"]');
    const image = card.querySelector('.card__media img');
    const price = card.querySelector('.price')?.innerText.replace(/\s+/g, ' ').trim() || '';
    return {
      url: normalizeUrl(link?.href || ''),
      title: card.querySelector('.card__heading')?.innerText.replace(/\s+/g, ' ').trim() || link?.textContent.trim() || '',
      image: image?.currentSrc || image?.src || '',
      alt: image?.alt || '',
      price,
    };
  };

  const getProductFromPage = () => {
    const image = document.querySelector('media-gallery .product__media img, media-gallery img');
    return {
      url: normalizeUrl(document.querySelector('link[rel="canonical"]')?.href || location.href),
      title: document.querySelector('.product__title h1, h1')?.innerText.replace(/\s+/g, ' ').trim() || document.title,
      image: image?.currentSrc || image?.src || '',
      alt: image?.alt || '',
      price: document.querySelector('.product__info-container .price')?.innerText.replace(/\s+/g, ' ').trim() || '',
    };
  };

  const isSaved = (url) => readWishlist().some((item) => item.url === normalizeUrl(url));

  const toggleProduct = (product) => {
    if (!product.url || !product.title) return;
    const items = readWishlist();
    const index = items.findIndex((item) => item.url === product.url);
    if (index >= 0) items.splice(index, 1);
    else items.unshift(product);
    writeWishlist(items);
  };

  const createHeaderButton = () => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'header__icon link focus-inset custom-wishlist-header-button';
    button.setAttribute('aria-label', 'Saved items');
    button.setAttribute('aria-haspopup', 'dialog');
    button.innerHTML = `${HEART_SVG}<span class="custom-wishlist-count" aria-hidden="true"></span>`;
    button.addEventListener('click', openDrawer);
    return button;
  };

  const initializeHeader = () => {
    let changed = false;
    document.querySelectorAll('header .header__icon--cart').forEach((cart) => {
      if (cart.parentElement.querySelector(':scope > .custom-wishlist-header-button')) return;
      cart.insertAdjacentElement('beforebegin', createHeaderButton());
      changed = true;
    });
    return changed;
  };

  const createCardButton = (card) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'custom-wishlist-card-button';
    button.innerHTML = HEART_SVG;
    return button;
  };

  window.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.custom-wishlist-card-button');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      const card = button.closest('.product-card-wrapper');
      toggleProduct(card ? getProductFromCard(card) : getProductFromPage());
    },
    true,
  );

  const initializeCards = (root = document) => {
    let changed = false;
    root.querySelectorAll('.product-card-wrapper').forEach((card) => {
      if (!card.querySelector('a[href*="/products/"]')) return;
      const media = card.querySelector('.card__inner, .media');
      if (!media || card.querySelector(':scope > .custom-wishlist-card-button')) return;
      card.append(createCardButton(card));
      changed = true;
    });
    return changed;
  };

  const initializeProductGallery = (root = document) => {
    if (!location.pathname.startsWith('/products/')) return false;
    const gallery = root.querySelector('media-gallery') || document.querySelector('media-gallery');
    if (!gallery) return false;
    const container = gallery.closest('.product__media-wrapper') || gallery;
    if (container.querySelector(':scope > .custom-wishlist-product-button')) return false;
    const button = createCardButton(document.body);
    button.classList.add('custom-wishlist-product-button');
    container.append(button);
    return true;
  };

  const ensureDrawer = () => {
    let drawer = document.querySelector('#CustomWishlistDrawer');
    if (drawer) return drawer;

    drawer = document.createElement('dialog');
    drawer.id = 'CustomWishlistDrawer';
    drawer.className = 'custom-wishlist-drawer';
    drawer.setAttribute('aria-labelledby', 'CustomWishlistTitle');
    drawer.innerHTML = `
      <div class="custom-wishlist-drawer__panel">
        <div class="custom-wishlist-drawer__header">
          <h2 id="CustomWishlistTitle">Saved Items</h2>
          <button type="button" class="custom-wishlist-drawer__close" aria-label="Close saved items">&times;</button>
        </div>
        <div class="custom-wishlist-drawer__items"></div>
      </div>`;
    drawer.querySelector('.custom-wishlist-drawer__close').addEventListener('click', () => drawer.close());
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) drawer.close();
    });
    document.body.append(drawer);
    return drawer;
  };

  const renderDrawer = () => {
    const container = ensureDrawer().querySelector('.custom-wishlist-drawer__items');
    const items = readWishlist();
    if (!items.length) {
      container.innerHTML = '<p class="custom-wishlist-empty">Your saved items will appear here.</p>';
      return;
    }

    container.replaceChildren(...items.map((item) => {
      const row = document.createElement('article');
      row.className = 'custom-wishlist-item';

      const link = document.createElement('a');
      link.className = 'custom-wishlist-item__link';
      link.href = item.url;
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = item.alt || item.title;
      image.loading = 'lazy';
      const details = document.createElement('span');
      details.className = 'custom-wishlist-item__details';
      const title = document.createElement('span');
      title.className = 'custom-wishlist-item__title';
      title.textContent = item.title;
      details.append(title);
      if (item.price) {
        const price = document.createElement('span');
        price.className = 'custom-wishlist-item__price';
        price.textContent = item.price;
        details.append(price);
      }
      link.append(image, details);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'custom-wishlist-item__remove';
      remove.setAttribute('aria-label', `Remove ${item.title} from saved items`);
      remove.innerHTML = `${HEART_SVG}<span>Remove</span>`;
      remove.addEventListener('click', () => toggleProduct(item));
      row.append(link, remove);
      return row;
    }));
  };

  function openDrawer() {
    const drawer = ensureDrawer();
    renderDrawer();
    if (!drawer.open) drawer.showModal();
  }

  const updateInterface = () => {
    const items = readWishlist();
    const urls = new Set(items.map((item) => item.url));
    document.querySelectorAll('.custom-wishlist-card-button').forEach((button) => {
      const card = button.closest('.product-card-wrapper');
      const product = card ? getProductFromCard(card) : getProductFromPage();
      const saved = urls.has(product.url);
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? 'Remove from' : 'Add to'} saved items: ${product.title}`);
    });
    document.querySelectorAll('.custom-wishlist-header-button').forEach((button) => {
      button.setAttribute('aria-label', items.length ? `Saved items, ${items.length}` : 'Saved items');
    });
    document.querySelectorAll('.custom-wishlist-count').forEach((badge) => {
      const count = items.length ? String(items.length) : '';
      if (badge.textContent !== count) badge.textContent = count;
      badge.hidden = !items.length;
    });
    if (document.querySelector('#CustomWishlistDrawer[open]')) renderDrawer();
  };

  const initialize = (root = document) => {
    initializeHeader();
    initializeCards(root);
    initializeProductGallery(root);
    ensureDrawer();
    updateInterface();
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('storage', updateInterface);
  new MutationObserver((mutations) => {
    if (!mutations.some((mutation) => mutation.addedNodes.length)) return;
    const headerChanged = initializeHeader();
    const cardsChanged = initializeCards();
    const galleryChanged = initializeProductGallery();
    if (headerChanged || cardsChanged || galleryChanged) updateInterface();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
